var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "dashboard-page-title" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            {
              staticClass:
                "flex justify-between items-center spacer-t-6 spacer-b-2",
            },
            [
              _c(
                "h1",
                { staticStyle: { margin: "0" } },
                [_vm._t("heading")],
                2
              ),
              _vm._v(" "),
              _vm.allowCreate
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      on: {
                        click: () => {
                          this.$emit("showModal", null)
                        },
                      },
                    },
                    [
                      _vm._v("\n          Add "),
                      _c("i", { staticClass: "fa fa-plus" }),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "table",
          {
            staticClass:
              "table table-hover table-tags table-data table-database-management",
          },
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.headings, function (heading) {
                    return _c("th", { key: heading.key }, [
                      _c(
                        "button",
                        {
                          staticClass: "th-button",
                          on: {
                            click: () => {
                              _vm.$emit("updateSort", heading.key)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(heading.label) +
                              "\n            "
                          ),
                          _vm.sort === heading.key
                            ? [
                                _vm.sortDir === "asc"
                                  ? _c("i", { staticClass: "fa fa-arrow-up" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortDir === "desc"
                                  ? _c("i", { staticClass: "fa fa-arrow-down" })
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _c("th", [_vm._v("Edit")]),
                  _vm._v(" "),
                  _vm.showDelete ? _c("th", [_vm._v("Delete")]) : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm.loading
                  ? _c("tr", [_vm._m(0)])
                  : _vm.entries && _vm.entries.length === "0"
                  ? _c("tr", [
                      _c(
                        "td",
                        { staticClass: "text-center", attrs: { colspan: "4" } },
                        [
                          _vm._v(
                            "\n          There are no entries that match your search\n        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._t("list"),
              ],
              2
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm._t("modal"),
      _vm._v(" "),
      _vm._t("departmentsModal"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "text-center", attrs: { colspan: "4" } }, [
      _c("i", {
        staticClass: "fa fa-circle-o-notch fa-spin fa-2x fa-fw text-muted",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }